export default {
    baseUrl: process.env.NODE_ENV === 'production' ? '' : 'http://127.0.0.1:8000',
    // baseUrl: '',
    // account
    url_authenticate: "/accounts/api/v1/authenticate",
    url_verify: "/accounts/api/v1/change-mobile-verify",
    url_mobile: "/accounts/api/v1/change-mobile",
    url_password: "/accounts/api/v1/change-password",
    url_login_email: "/accounts/api/v1/login-by-email",
    url_login_mobile: "/accounts/api/v1/login-by-mobile",
    url_logout: "/accounts/api/v1/logout",
    url_user_detail: "/accounts/api/v1/user-detail",
    url_user_update: "/accounts/api/v1/user-panel-update",

    // profile
    url_user_notification: "/accounts/api/v1/user-notifications",
    url_wishlist: "/accounts/api/v1/wishlist",
    url_wishlist_remove: "/accounts/api/v1/wishlist-remove",
    url_order_create: "/checkout/api/v1/order-create",
    url_address_create: "/checkout/api/v1/address-create",
    url_address_delete: "/checkout/api/v1/user-address-delete",
    url_address_update: "/checkout/api/v1/user-address-update",
    url_address_default: "/checkout/api/v1/address-default",
    // 
    url_address_list: "/checkout/api/v1/user-address-list",
    url_country_list: "/shipping/api/v1/country-list",
    url_order_delete: "/checkout/api/v1/user-order-delete",
    url_user_order_detail: "/checkout/api/v1/user-order-detail",
    
    url_order_cancel: "/checkout/api/v1/user-order-cancel",
    url_order_pay: "/checkout/api/v1/user-order-pay",
    url_user_progress_order_list: "/checkout/api/v1/user-progress-order-list",
    url_user_cancel_order_list: "/checkout/api/v1/user-cancel-order-list",
    url_user_complete_order_list: "/checkout/api/v1/user-complete-order-list",
    
    url_order_upload: "/checkout/api/v1/user-order-upload",
    url_send_card_number: "/checkout/api/v1/send-card-number",
    url_order_detail: "/checkout/api/v1/order-detail",
    // defaultAddress: '/',
    //order
    invoice: '/checkout/api/v1/invoice',

    // checkout
    getPayment: '/',
    addCoupon: '/',
    deleteCoupon: '/',
    add_coupon: '/checkout/api/v1/coupon-add',
    remove_coupon: '/checkout/api/v1/coupon-remove',
    shipping: '/checkout/api/v1/shipping',
    payment: '/checkout/api/v1/payment',
    getShippingPrice: '/',
};